export const firebase = {
    app: {
        name: 'qurage-link',
        options: {
            apiKey: 'AIzaSyAlPGxbyq1SyqpaFDlZj4z0xmnbYggsNJI',
            authDomain: 'qurage-a80f2.firebaseapp.com',
            databaseURL: 'https://qurage-a80f2.firebaseio.com',
            projectId: 'qurage-a80f2',
            storageBucket: 'qurage-a80f2.appspot.com',
            messagingSenderId: '980706569173'
        }
    },
    functions: {
        region: 'us-central1'
    },
    firestore: {
        settings: {}
    }
};
export const deepLink = {
    domain: 'quragelink.page.link',
    link: 'quralink.com',
    apn: 'jp.bfac.bap.qurage',
    isi: '1435874210',
    ibi: 'jp.bfac.bap.qurage'
};
